import { ROUTE_CONSTANT } from "./route-constants";
import SignIn from "../pages/sign-in/component";
import SignUp from "../pages/sign-up/component";
import AdminLogin from "../pages/admin-login/component";
import SignOut from "../pages/sign-out/component";
import PageNotFound from "../pages/page-not-found/component";
import SessionExpire from "../pages/session-expire/component";
import Home from "../pages/home/component";
import ForgotPassword from "../pages/forgot-password/component";
import ResetPassword from "../pages/reset-password/component";
export const ComponentList = {
  SignIn: {
    Component: <SignIn />,
    Path: ROUTE_CONSTANT.SIGNIN,
    LocalePath: ROUTE_CONSTANT.SIGNIN_LOCALE,
  },
  SignUp: {
    Component: <SignUp />,
    Path: ROUTE_CONSTANT.SIGNUP,
    LocalePath: ROUTE_CONSTANT.SIGNUP_LOCALE,
  },
  SignOut: {
    Component: <SignOut />,
    Path: ROUTE_CONSTANT.SIGNOUT,
    LocalePath: ROUTE_CONSTANT.SIGNOUT_LOCALE,
  },
  AdminLogin: {
    Component: <AdminLogin />,
    Path: ROUTE_CONSTANT.ADMIN_LOGIN,
  },
  PageNotFound: {
    Component: <PageNotFound />,
    Path: ROUTE_CONSTANT.PAGE_NOT_FOUND,
    LocalePath: ROUTE_CONSTANT.PAGE_NOT_FOUND_LOCALE,
  },
  SessionExpire: {
    Component: <SessionExpire />,
    Path: ROUTE_CONSTANT.SESSION_EXPIRE,
    LocalePath: ROUTE_CONSTANT.SESSION_EXPIRE_LOCALE,
  },
  Home: {
    Component: <Home />,
    Path: ROUTE_CONSTANT.HOME,
    LocalePath: ROUTE_CONSTANT.HOME_LOCALE,
  },
  ForgotPassword: {
    Component: <ForgotPassword />,
    Path: ROUTE_CONSTANT.FORGOT_PASSWORD,
    LocalePath: ROUTE_CONSTANT.FORGOT_PASSWORD_LOCALE,
  },
  ResetPassword: {
    Component: <ResetPassword />,
    Path: ROUTE_CONSTANT.RESET_PASSWORD,
    LocalePath: ROUTE_CONSTANT.RESET_PASSWORD_LOCALE,
  },
};
